import { render, staticRenderFns } from "./RmpAlertsSnackbar.vue?vue&type=template&id=2afe92bc"
import script from "./RmpAlertsSnackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpAlertsSnackbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RmpAlertsSnackbar.vue?vue&type=style&index=0&id=2afe92bc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports